// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/event_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { ChatChangeEvent } from "./chat_types.js";
import { GroupChangeEvent } from "./group_types.js";
import { MessageChangeEvent } from "./message_types.js";
import { PollChangeEvent } from "./poll_types.js";
import { Heartbeat } from "./streaming.js";

export const protobufPackage = "photon.imessage.v1";

export interface CatchUpEventsRequest {
  /** Resume cursor; absent = replay every event the server still holds. */
  afterSequence?: number | undefined;
}

/**
 * Terminal frame.
 *
 * `head_sequence` is the fixed global head captured when this catch-up
 * started. This stream replays every event with:
 *
 *   after_sequence < sequence <= head_sequence
 *
 * Then it terminates. The caller resumes live by passing `head_sequence`
 * as `after_sequence` to a `Subscribe*` stream.
 */
export interface CatchUpEventsComplete {
  headSequence: number;
}

export interface CatchUpEventsResponse {
  /**
   * Monotonic global sequence; absent only on the terminal `complete`
   * frame.
   */
  sequence?: number | undefined;
  messageChanged?: MessageChangeEvent | undefined;
  groupChanged?: GroupChangeEvent | undefined;
  pollChanged?: PollChangeEvent | undefined;
  chatChanged?: ChatChangeEvent | undefined;
  complete?: CatchUpEventsComplete | undefined;
  heartbeat?: Heartbeat | undefined;
}

function createBaseCatchUpEventsRequest(): CatchUpEventsRequest {
  return { afterSequence: undefined };
}

export const CatchUpEventsRequest: MessageFns<CatchUpEventsRequest> = {
  encode(message: CatchUpEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.afterSequence !== undefined) {
      writer.uint32(8).uint64(message.afterSequence);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatchUpEventsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatchUpEventsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.afterSequence = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CatchUpEventsRequest {
    return {
      afterSequence: isSet(object.afterSequence)
        ? globalThis.Number(object.afterSequence)
        : isSet(object.after_sequence)
        ? globalThis.Number(object.after_sequence)
        : undefined,
    };
  },

  toJSON(message: CatchUpEventsRequest): unknown {
    const obj: any = {};
    if (message.afterSequence !== undefined) {
      obj.afterSequence = Math.round(message.afterSequence);
    }
    return obj;
  },

  create(base?: DeepPartial<CatchUpEventsRequest>): CatchUpEventsRequest {
    return CatchUpEventsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CatchUpEventsRequest>): CatchUpEventsRequest {
    const message = createBaseCatchUpEventsRequest();
    message.afterSequence = object.afterSequence ?? undefined;
    return message;
  },
};

function createBaseCatchUpEventsComplete(): CatchUpEventsComplete {
  return { headSequence: 0 };
}

export const CatchUpEventsComplete: MessageFns<CatchUpEventsComplete> = {
  encode(message: CatchUpEventsComplete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.headSequence !== 0) {
      writer.uint32(8).uint64(message.headSequence);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatchUpEventsComplete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatchUpEventsComplete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.headSequence = longToNumber(reader.uint64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CatchUpEventsComplete {
    return {
      headSequence: isSet(object.headSequence)
        ? globalThis.Number(object.headSequence)
        : isSet(object.head_sequence)
        ? globalThis.Number(object.head_sequence)
        : 0,
    };
  },

  toJSON(message: CatchUpEventsComplete): unknown {
    const obj: any = {};
    if (message.headSequence !== 0) {
      obj.headSequence = Math.round(message.headSequence);
    }
    return obj;
  },

  create(base?: DeepPartial<CatchUpEventsComplete>): CatchUpEventsComplete {
    return CatchUpEventsComplete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CatchUpEventsComplete>): CatchUpEventsComplete {
    const message = createBaseCatchUpEventsComplete();
    message.headSequence = object.headSequence ?? 0;
    return message;
  },
};

function createBaseCatchUpEventsResponse(): CatchUpEventsResponse {
  return {
    sequence: undefined,
    messageChanged: undefined,
    groupChanged: undefined,
    pollChanged: undefined,
    chatChanged: undefined,
    complete: undefined,
    heartbeat: undefined,
  };
}

export const CatchUpEventsResponse: MessageFns<CatchUpEventsResponse> = {
  encode(message: CatchUpEventsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sequence !== undefined) {
      writer.uint32(8).uint64(message.sequence);
    }
    if (message.messageChanged !== undefined) {
      MessageChangeEvent.encode(message.messageChanged, writer.uint32(82).fork()).join();
    }
    if (message.groupChanged !== undefined) {
      GroupChangeEvent.encode(message.groupChanged, writer.uint32(90).fork()).join();
    }
    if (message.pollChanged !== undefined) {
      PollChangeEvent.encode(message.pollChanged, writer.uint32(98).fork()).join();
    }
    if (message.chatChanged !== undefined) {
      ChatChangeEvent.encode(message.chatChanged, writer.uint32(106).fork()).join();
    }
    if (message.complete !== undefined) {
      CatchUpEventsComplete.encode(message.complete, writer.uint32(162).fork()).join();
    }
    if (message.heartbeat !== undefined) {
      Heartbeat.encode(message.heartbeat, writer.uint32(794).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CatchUpEventsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCatchUpEventsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sequence = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.messageChanged = MessageChangeEvent.decode(reader, reader.uint32());
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.groupChanged = GroupChangeEvent.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.pollChanged = PollChangeEvent.decode(reader, reader.uint32());
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.chatChanged = ChatChangeEvent.decode(reader, reader.uint32());
          continue;
        }
        case 20: {
          if (tag !== 162) {
            break;
          }

          message.complete = CatchUpEventsComplete.decode(reader, reader.uint32());
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.heartbeat = Heartbeat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CatchUpEventsResponse {
    return {
      sequence: isSet(object.sequence) ? globalThis.Number(object.sequence) : undefined,
      messageChanged: isSet(object.messageChanged)
        ? MessageChangeEvent.fromJSON(object.messageChanged)
        : isSet(object.message_changed)
        ? MessageChangeEvent.fromJSON(object.message_changed)
        : undefined,
      groupChanged: isSet(object.groupChanged)
        ? GroupChangeEvent.fromJSON(object.groupChanged)
        : isSet(object.group_changed)
        ? GroupChangeEvent.fromJSON(object.group_changed)
        : undefined,
      pollChanged: isSet(object.pollChanged)
        ? PollChangeEvent.fromJSON(object.pollChanged)
        : isSet(object.poll_changed)
        ? PollChangeEvent.fromJSON(object.poll_changed)
        : undefined,
      chatChanged: isSet(object.chatChanged)
        ? ChatChangeEvent.fromJSON(object.chatChanged)
        : isSet(object.chat_changed)
        ? ChatChangeEvent.fromJSON(object.chat_changed)
        : undefined,
      complete: isSet(object.complete) ? CatchUpEventsComplete.fromJSON(object.complete) : undefined,
      heartbeat: isSet(object.heartbeat) ? Heartbeat.fromJSON(object.heartbeat) : undefined,
    };
  },

  toJSON(message: CatchUpEventsResponse): unknown {
    const obj: any = {};
    if (message.sequence !== undefined) {
      obj.sequence = Math.round(message.sequence);
    }
    if (message.messageChanged !== undefined) {
      obj.messageChanged = MessageChangeEvent.toJSON(message.messageChanged);
    }
    if (message.groupChanged !== undefined) {
      obj.groupChanged = GroupChangeEvent.toJSON(message.groupChanged);
    }
    if (message.pollChanged !== undefined) {
      obj.pollChanged = PollChangeEvent.toJSON(message.pollChanged);
    }
    if (message.chatChanged !== undefined) {
      obj.chatChanged = ChatChangeEvent.toJSON(message.chatChanged);
    }
    if (message.complete !== undefined) {
      obj.complete = CatchUpEventsComplete.toJSON(message.complete);
    }
    if (message.heartbeat !== undefined) {
      obj.heartbeat = Heartbeat.toJSON(message.heartbeat);
    }
    return obj;
  },

  create(base?: DeepPartial<CatchUpEventsResponse>): CatchUpEventsResponse {
    return CatchUpEventsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CatchUpEventsResponse>): CatchUpEventsResponse {
    const message = createBaseCatchUpEventsResponse();
    message.sequence = object.sequence ?? undefined;
    message.messageChanged = (object.messageChanged !== undefined && object.messageChanged !== null)
      ? MessageChangeEvent.fromPartial(object.messageChanged)
      : undefined;
    message.groupChanged = (object.groupChanged !== undefined && object.groupChanged !== null)
      ? GroupChangeEvent.fromPartial(object.groupChanged)
      : undefined;
    message.pollChanged = (object.pollChanged !== undefined && object.pollChanged !== null)
      ? PollChangeEvent.fromPartial(object.pollChanged)
      : undefined;
    message.chatChanged = (object.chatChanged !== undefined && object.chatChanged !== null)
      ? ChatChangeEvent.fromPartial(object.chatChanged)
      : undefined;
    message.complete = (object.complete !== undefined && object.complete !== null)
      ? CatchUpEventsComplete.fromPartial(object.complete)
      : undefined;
    message.heartbeat = (object.heartbeat !== undefined && object.heartbeat !== null)
      ? Heartbeat.fromPartial(object.heartbeat)
      : undefined;
    return message;
  },
};

/**
 * Unified finite replay across every durable event domain:
 * messages, group state, polls, and chats.
 *
 * Drains everything newer than `after_sequence` and terminates with
 * `CatchUpEventsComplete`, after which the caller hands off to the live
 * `Subscribe*` streams without gaps.
 *
 * All `sequence` values returned here share the same global event log
 * as `SubscribeMessageEvents`, `SubscribeGroupEvents`, `SubscribePollEvents`,
 * and `SubscribeChatEvents`.
 */
export type EventServiceDefinition = typeof EventServiceDefinition;
export const EventServiceDefinition = {
  name: "EventService",
  fullName: "photon.imessage.v1.EventService",
  methods: {
    catchUpEvents: {
      name: "CatchUpEvents",
      requestType: CatchUpEventsRequest as typeof CatchUpEventsRequest,
      requestStream: false,
      responseType: CatchUpEventsResponse as typeof CatchUpEventsResponse,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface EventServiceImplementation<CallContextExt = {}> {
  catchUpEvents(
    request: CatchUpEventsRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<CatchUpEventsResponse>>;
}

export interface EventServiceClient<CallOptionsExt = {}> {
  catchUpEvents(
    request: DeepPartial<CatchUpEventsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<CatchUpEventsResponse>;
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
